import { downgradeInjectable } from '@angular/upgrade/static';
import 'angular';

import '../sessions/sessions.module';

import { CompanyIntegrationFilter } from './company.integration.filter.ajs';
import { CompanyIntegrationPipe }   from './company.integration.pipe';
import { CompanyService }           from './company.service';

angular.module('app-lite.companies', [
  'app-lite.sessions'
])
  .filter('companyIntegration', CompanyIntegrationFilter)
  .service('companyIntegrationPipe', downgradeInjectable(CompanyIntegrationPipe))
  .service('companyApi', downgradeInjectable(CompanyService));
